import axios from "axios";
import { collaboratorsHistoryUrl } from "../../../utils";

export const fetchCollaboratorsHistory = async (professionalId?: string) => {
  return await axios.get(collaboratorsHistoryUrl(professionalId));
};
